var _excluded = ["placement", "mode", "size", "className", "content"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { combineClasses } from '@okee-uikit/react-utils';
import { useDirection, usePrefixCls } from '@okee-uikit/react-config';
import { PopoverContent } from '../popover/PopoverContent';
var placementMap = {
  'top-start': 'top-end',
  top: 'top',
  'top-end': 'top-start',
  'bottom-start': 'bottom-end',
  bottom: 'bottom',
  'bottom-end': 'bottom-start',
  'left-start': 'right-start',
  left: 'right',
  'left-end': 'right-end',
  'right-start': 'left-start',
  right: 'left',
  'right-end': 'left-end'
};
export function TooltipContent(props) {
  var _props$placement = props.placement,
      propPlacement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'dark' : _props$mode,
      size = props.size,
      className = props.className,
      content = props.content,
      extra = _objectWithoutProperties(props, _excluded);

  var rtl = useDirection() === 'rtl';
  var placement = rtl && placementMap[propPlacement] || propPlacement;
  var popoverCls = combineClasses(usePrefixCls('tooltip-popover', {
    mode: mode,
    size: size,
    rtl: rtl
  }), className);
  var innerCls = usePrefixCls('tooltip-inner', {
    rtl: rtl
  });
  var renderPopper = useCallback(function () {
    return React.createElement("div", {
      className: innerCls
    }, typeof content === 'function' ? content() : content);
  }, [content]);
  return React.createElement(PopoverContent, _objectSpread(_objectSpread({}, extra), {}, {
    className: popoverCls,
    placement: placement,
    getPopper: renderPopper
  }));
}